var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{staticClass:"mc-alert",attrs:{"show":"","variant":"primary"}},[_c('i',{staticClass:"mc-fa icon-fill_info"}),_vm._v(" "+_vm._s(_vm.$t('report.text.showReportPartly')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }